"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTitle = exports.getIcon = exports.default = exports.SingleValue = exports.SELECT_DISPLAY_NAME = exports.Option = exports.MultiValueLabel = exports.MultiSelectInput = exports.Menu = exports.ClearIndicator = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _recompose = require("recompose");
var _classnames = _interopRequireDefault(require("classnames"));
var _path = _interopRequireDefault(require("ramda/src/path"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _Text = require("../../Text/Text");
var _InputRequired = _interopRequireDefault(require("../InputRequired/InputRequired"));
var _ModalView = require("../../View/ModalView/ModalView");
var _excluded = ["children", "isDisabled", "isFocused", "innerProps", "innerRef", "menuIsOpen"],
  _excluded2 = ["children", "getPortalPlacement", "innerProps", "innerRef", "maxMenuHeight", "menuPlacement", "menuPosition", "menuShouldScrollIntoView", "minMenuHeight"],
  _excluded3 = ["data-testid", "autoFocus", "classes", "className", "component", "defaultValue", "disabled", "displayErrors", "embedded", "fixedMenuHeight", "hasError", "hasRequired", "hasSuccess", "hasValidation", "id", "inputClassName", "inputRef", "intl", "isDisabled", "isMulti", "isSearchable", "modalViewContext", "name", "noOptionsMessage", "onBlur", "onChange", "onPaste", "options", "readOnly", "required", "setDisplayErrorsState", "setLoadingState", "theme", "title"],
  _excluded4 = ["outline"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: import { type ControlProps } from 'react-select/src/components/Control';*/ /*:: import { type MenuProps } from 'react-select/src/components/Menu';*/ /*:: import { type MultiValueGenericProps } from 'react-select/src/components/MultiValue';*/ /*:: import { type OptionProps } from 'react-select/src/components/Option';*/ /*:: import { type SingleValueProps } from 'react-select/src/components/SingleValue';*/ /*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var DEFAULT_VALUE = [];
var NOOP = function NOOP() {};
var SELECT_DISPLAY_NAME = exports.SELECT_DISPLAY_NAME = 'MultiSelectInput';
var MENU_MAX_HEIGHT = 300;
var Style = function Style(theme /*: ThemeType*/) {
  var _input;
  return {
    root: {
      position: 'relative'
    },
    input: (_input = {
      '&:required:valid': {
        '& ~ $required': {
          display: 'none'
        }
      }
    }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_input, "& .".concat(SELECT_DISPLAY_NAME, "__clear-indicator"), {
      display: 'none',
      // Hides clear indicator button
      padding: '.5rem',
      color: theme.colors.battleshipGrey,
      cursor: 'pointer',
      '&:hover': {
        color: theme.colors.black
      }
    }), "& .".concat(SELECT_DISPLAY_NAME, "__control"), _objectSpread(_objectSpread(_objectSpread({}, theme.mixins.inputStyle), theme.mixins.inputMultiPadding), {}, (0, _defineProperty2.default)({
      minHeight: 0
    }, "&.".concat(SELECT_DISPLAY_NAME, "__control--is-focused"), theme.mixins.inputFocus))), "& .".concat(SELECT_DISPLAY_NAME, "__dropdown-indicator"), {
      padding: '.5rem',
      color: theme.colors.battleshipGrey,
      cursor: 'pointer',
      '&:hover': {
        color: theme.colors.black
      }
    }), "& .".concat(SELECT_DISPLAY_NAME, "__indicators"), {
      marginRight: '-.5rem'
    }), "& .".concat(SELECT_DISPLAY_NAME, "__indicator-separator"), {
      backgroundColor: theme.colors.battleshipGrey,
      marginBottom: '.5rem',
      marginTop: '.5rem',
      width: '1px',
      display: 'none'
    }), "& .".concat(SELECT_DISPLAY_NAME, "__menu"), _objectSpread(_objectSpread({}, theme.mixins.inputMenu), {}, {
      borderRadius: '.25rem',
      marginTop: '.5rem',
      marginBottom: '.5rem',
      zIndex: function zIndex(_ref) {
        var modalViewContext = _ref.modalViewContext;
        return "".concat(modalViewContext ? theme.zIndex.modal : theme.zIndex.menu);
      }
    })), "& .".concat(SELECT_DISPLAY_NAME, "__menu-list"), {
      /* react-select has a bug where the maxMenuHeight
       * prop is ignored if menuPlacement is set to auto and
       * the menu opens above the input
       * https://github.com/JedWatson/react-select/issues/3278 */
      maxHeight: theme.functions.toRem(MENU_MAX_HEIGHT),
      paddingTop: 0,
      paddingBottom: 0
    }), "& .".concat(SELECT_DISPLAY_NAME, "__menu-notice--loading"), theme.mixins.inputEmpty), "& .".concat(SELECT_DISPLAY_NAME, "__menu-notice--no-options"), theme.mixins.inputEmpty), "& .".concat(SELECT_DISPLAY_NAME, "__multi-value"), _objectSpread(_objectSpread({}, theme.mixins.inputMultiValue), {}, (0, _defineProperty2.default)({}, "&.".concat(SELECT_DISPLAY_NAME, "__multi-value--is-disabled"), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "& .".concat(SELECT_DISPLAY_NAME, "__multi-value__label"), theme.mixins.inputMultiLabelDisabled), "& .".concat(SELECT_DISPLAY_NAME, "__multi-value__remove"), theme.mixins.inputMultiRemoveDisabled)))), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_input, "& .".concat(SELECT_DISPLAY_NAME, "__multi-value__chipContainer"), {
      minWidth: 0,
      display: 'flex'
    }), "& .".concat(SELECT_DISPLAY_NAME, "__multi-value__chipIcon"), {
      '& > *': {
        width: '1rem',
        height: '1rem',
        margin: '.25rem 0 0 .25rem',
        '& img': {
          verticalAlign: 'top'
        }
      }
    }), "& .".concat(SELECT_DISPLAY_NAME, "__multi-value__optionIcon"), {
      '& > *': {
        width: '1.25rem',
        height: '1.25rem',
        position: 'relative',
        top: '.2rem',
        marginRight: '.5rem',
        '& img': {
          verticalAlign: 'top'
        }
      }
    }), "& .".concat(SELECT_DISPLAY_NAME, "__multi-value__label"), theme.mixins.inputMultiLabel), "& .".concat(SELECT_DISPLAY_NAME, "__multi-value__remove"), theme.mixins.inputMultiRemove), "& .".concat(SELECT_DISPLAY_NAME, "__option"), _objectSpread(_objectSpread(_objectSpread({}, theme.typography.baseText), theme.mixins.truncate), {}, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
      padding: '.5rem .75rem',
      minHeight: '2.375rem',
      cursor: 'pointer'
    }, "&.".concat(SELECT_DISPLAY_NAME, "__option--is-focused"), (0, _defineProperty2.default)({}, "&, &.".concat(SELECT_DISPLAY_NAME, "__option--is-selected"), {
      backgroundColor: theme.colors.blueGrey,
      color: theme.colors.black
    })), "&.".concat(SELECT_DISPLAY_NAME, "__option--is-selected"), {
      backgroundColor: theme.colors.white,
      color: theme.colors.black
    }), '&:active', {
      backgroundColor: theme.colors.blueGrey,
      color: theme.colors.black
    }))), "& .".concat(SELECT_DISPLAY_NAME, "__placeholder"), theme.mixins.inputPlaceholder), "& .".concat(SELECT_DISPLAY_NAME, "__single-value"), _objectSpread(_objectSpread({}, theme.typography.baseText), {}, (0, _defineProperty2.default)({
      color: theme.colors.black
    }, "&.".concat(SELECT_DISPLAY_NAME, "__single-value--is-disabled"), theme.mixins.inputMultiLabelDisabled))), "& .".concat(SELECT_DISPLAY_NAME, "__value-container"), _objectSpread(_objectSpread({}, theme.mixins.inputContainer), {}, {
      overflow: 'hidden'
    })), "& .".concat(SELECT_DISPLAY_NAME, "__value-container--is-multi.").concat(SELECT_DISPLAY_NAME, "__value-container--has-value"), {
      marginLeft: '-.563rem'
    })),
    success: (0, _defineProperty2.default)({}, "& .".concat(SELECT_DISPLAY_NAME, "__control"), (0, _defineProperty2.default)({}, "&, &.".concat(SELECT_DISPLAY_NAME, "__control--is-focused"), theme.mixins.inputSuccess)),
    error: (0, _defineProperty2.default)({}, "& .".concat(SELECT_DISPLAY_NAME, "__control"), (0, _defineProperty2.default)({}, "&, &.".concat(SELECT_DISPLAY_NAME, "__control--is-focused"), theme.mixins.inputError)),
    required: _objectSpread(_objectSpread({}, theme.mixins.inputRequired), {}, {
      right: '1.563rem'
    }),
    readOnly: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "& .".concat(SELECT_DISPLAY_NAME, "__indicators"), {
      display: 'none'
    }), "& .".concat(SELECT_DISPLAY_NAME, "__multi-value"), (0, _defineProperty2.default)({}, "&.".concat(SELECT_DISPLAY_NAME, "__multi-value--is-disabled"), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "& .".concat(SELECT_DISPLAY_NAME, "__multi-value__label, & .").concat(SELECT_DISPLAY_NAME, "__multi-value__remove"), {
      color: theme.colors.black
    }), "& .".concat(SELECT_DISPLAY_NAME, "__multi-value__remove"), {
      display: 'none'
    }))), "& .".concat(SELECT_DISPLAY_NAME, "__single-value"), (0, _defineProperty2.default)({}, "&.".concat(SELECT_DISPLAY_NAME, "__single-value--is-disabled"), {
      color: theme.colors.black
    })),
    inputElement: (0, _defineProperty2.default)({}, "&.".concat(SELECT_DISPLAY_NAME, "__control"), {
      cursor: 'pointer'
    }),
    inputShadow: {
      display: 'none'
    },
    embedded: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "& .".concat(SELECT_DISPLAY_NAME, "__control"), {
      backgroundColor: theme.colors.ghostWhite,
      border: "1px solid ".concat(theme.colors.lightGrey),
      borderRadius: theme.variables.borderRadiusSmall,
      paddingTop: 0,
      paddingBottom: 0,
      '&:hover, &:focus, &:focus-within': {
        backgroundColor: theme.colors.ghostWhite,
        border: "1px solid ".concat(theme.colors.lightGrey)
      }
    }), "& .".concat(SELECT_DISPLAY_NAME, "__multi-value__label"), {
      padding: '.063rem .5rem',
      minHeight: '1.375rem'
    }), "& .".concat(SELECT_DISPLAY_NAME, "__option"), _objectSpread({}, theme.typography.smallText)), "& .".concat(SELECT_DISPLAY_NAME, "__single-value"), _objectSpread({}, theme.typography.smallText)), "& .".concat(SELECT_DISPLAY_NAME, "__placeholder"), _objectSpread({}, theme.typography.smallText)), "& .".concat(SELECT_DISPLAY_NAME, "__value-container"), {
      minHeight: '1.875rem'
    }), "& .".concat(SELECT_DISPLAY_NAME, "__input"), {
      '& input': {
        margin: 0
      }
    }), "& .".concat(SELECT_DISPLAY_NAME, "__dropdown-indicator"), {
      paddingTop: 0,
      paddingBottom: 0
    }), "& .".concat(SELECT_DISPLAY_NAME, "__multi-value__chipIcon"), {
      lineHeight: '1rem',
      '& > *': {
        marginTop: '.1875rem'
      }
    }), '& input', {
      paddingTop: 0,
      paddingBottom: 0
    }),
    fixedMenuHeight: (0, _defineProperty2.default)({}, "& .".concat(SELECT_DISPLAY_NAME, "__menu-list"), {
      minHeight: theme.functions.toRem(MENU_MAX_HEIGHT)
    }),
    menuNotice: {
      display: 'block',
      margin: '.5rem auto',
      paddingTop: '.25rem',
      paddingBottom: '.25rem'
    }
  };
};
/*:: export type OptionType = { [string]: any };*/
/*:: export type OptionsType = Array<OptionType>;*/
/*:: export type ValueType = OptionType | OptionsType | null | void;*/
/*:: export type InputActionMeta = { action: string };*/
/*:: export type MultiSelectInputProps = {
  ...HTMLSelectElement,
  'data-testid'?: string,
  autoFocus?: boolean,
  component?: React.ComponentType<*>,
  defaultValue?: ValueType,
  displayErrors?: boolean,
  embedded?: boolean,
  fixedMenuHeight?: boolean,
  hasError?: boolean,
  hasRequired?: boolean,
  hasSuccess?: boolean,
  hasValidation?: boolean,
  inputClassName?: string,
  isDisabled?: boolean,
  isMulti?: boolean,
  isSearchable?: boolean,
  noOptionsMessage?: () => React.Node,
  onBlur?: ({
    currentTarget: {
      id?: string,
      label: React.Node,
      name?: string,
      value: ValueType
    }
  }) => void,
  onChange?: (
    {
      currentTarget: {
        id?: string,
        label: React.Node,
        name?: string,
        value: ValueType
      }
    },
    ValueType,
    OptionsType
  ) => void,
  options?: OptionsType,
  readOnly?: boolean,
  required?: boolean,
  setDisplayErrorsState?: (displayErrors: boolean) => mixed,
  setLoadingState?: (loading: boolean) => mixed,
  value?: ValueType
};*/
/*:: export type MultiSelectInputType = InjectSheetProvidedProps & {
  ...MultiSelectInputProps,
  inputRef: React.ElementRef<*>,
  intl: Object,
  modalViewContext: boolean,
  // Default Props - same as above but no longer optional
  autoComplete: boolean,
  autoFocus: boolean,
  component: React.ComponentType<*>,
  disabled: boolean,
  displayErrors: boolean,
  hasError: boolean,
  hasRequired: boolean,
  hasSuccess: boolean,
  isClearable: boolean,
  isDisabled: boolean,
  isMulti: boolean,
  isSearchable: boolean,
  maxMenuHeight: number,
  menuPlacement: string,
  noOptionsMessage: () => React.Node,
  onPaste?: (event: SyntheticClipboardEvent<HTMLElement>) => mixed,
  options: OptionsType,
  readOnly: boolean,
  required: boolean
};*/
/*:: type State = {
  defaultValue: ValueType
};*/
var getIcon = exports.getIcon = function getIcon(_ref2 /*:: */) {
  var data = _ref2 /*:: */.data;
  var _ref3 = data || {},
    icon = _ref3.icon;
  return icon;
};
var getTitle = exports.getTitle = function getTitle(_ref4 /*:: */) {
  var children = _ref4 /*:: */.children,
    data = _ref4 /*:: */.data;
  var _ref5 = data || {},
    title = _ref5.title;
  return typeof title === 'string' || typeof title === 'number' ? title : typeof children === 'string' || typeof title === 'number' ? children : '';
};
var ClearIndicator = exports.ClearIndicator = function ClearIndicator() {
  return null;
};
ClearIndicator.displayName = 'ClearIndicator';
var Control = function Control(props /*: ControlProps*/) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    menuIsOpen = props.menuIsOpen,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  var inputClassName = (0, _path.default)(['selectProps', 'inputClassName'], props);
  var isMulti = (0, _path.default)(['selectProps', 'isMulti'], props);
  return /*#__PURE__*/React.createElement(_reactSelect.components.Control, (0, _extends2.default)({
    className: (0, _classnames.default)(inputClassName, (0, _defineProperty2.default)({}, "".concat(SELECT_DISPLAY_NAME, "__control--is-multi"), isMulti)),
    innerProps: _objectSpread(_objectSpread({}, innerProps), {}, {
      'data-testid': 'control',
      tabIndex: '0'
    }),
    innerRef: innerRef,
    isDisabled: isDisabled,
    isFocused: isFocused,
    menuIsOpen: menuIsOpen
  }, other), children);
};
Control.displayName = 'Control';
var IndicatorSeparator = function IndicatorSeparator() {
  return null;
};
IndicatorSeparator.displayName = 'IndicatorSeparator';
var LoadingIndicator = function LoadingIndicator() {
  return null;
};
LoadingIndicator.displayName = 'LoadingIndicator';
var Menu = exports.Menu = function Menu(_ref6 /*:: */) {
  var children = _ref6 /*:: */.children,
    getPortalPlacement = _ref6 /*:: */.getPortalPlacement,
    innerProps = _ref6 /*:: */.innerProps,
    innerRef = _ref6 /*:: */.innerRef,
    maxMenuHeight = _ref6 /*:: */.maxMenuHeight,
    menuPlacement = _ref6 /*:: */.menuPlacement,
    menuPosition = _ref6 /*:: */.menuPosition,
    menuShouldScrollIntoView = _ref6 /*:: */.menuShouldScrollIntoView,
    minMenuHeight = _ref6 /*:: */.minMenuHeight,
    props = (0, _objectWithoutProperties2.default)(_ref6 /*:: */, _excluded2);
  return /*#__PURE__*/React.createElement(_reactSelect.components.Menu, (0, _extends2.default)({
    getPortalPlacement: getPortalPlacement,
    innerProps: _objectSpread(_objectSpread({}, innerProps), {}, {
      'data-testid': 'menu'
    }),
    innerRef: innerRef,
    maxMenuHeight: maxMenuHeight,
    menuPlacement: menuPlacement,
    menuPosition: menuPosition,
    menuShouldScrollIntoView: menuShouldScrollIntoView,
    minMenuHeight: minMenuHeight
  }, props), children);
};
Menu.displayName = 'Menu';
var MultiValueLabel = exports.MultiValueLabel = function MultiValueLabel(props /*: MultiValueGenericProps*/) {
  var title = getTitle(props);
  var icon = getIcon(props);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(SELECT_DISPLAY_NAME, "__multi-value__chipContainer"),
    title: title,
    "data-testid": "multi-value"
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: "".concat(SELECT_DISPLAY_NAME, "__multi-value__chipIcon")
  }, icon), /*#__PURE__*/React.createElement(_reactSelect.components.MultiValueLabel, props));
};
MultiValueLabel.displayName = 'MultiValueLabel';
var Option = exports.Option = function Option(props /*: OptionProps*/) {
  var title = getTitle(props);
  var icon = getIcon(props);
  return /*#__PURE__*/React.createElement("div", {
    title: title,
    "data-testid": "option",
    "data-value": String(props.data.value)
  }, /*#__PURE__*/React.createElement(_reactSelect.components.Option, props, icon && /*#__PURE__*/React.createElement("span", {
    className: "".concat(SELECT_DISPLAY_NAME, "__multi-value__optionIcon")
  }, icon), props.data.label));
};
Option.displayName = 'Option';
var SingleValue = exports.SingleValue = function SingleValue(props /*: SingleValueProps*/) {
  // eslint-disable-next-line flowtype-errors/show-errors
  var title = getTitle(props);
  var icon = getIcon(props);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(SELECT_DISPLAY_NAME, "__single-value-container"),
    "data-testid": "single-value",
    title: title
  }, /*#__PURE__*/React.createElement(_reactSelect.components.SingleValue, props, icon && /*#__PURE__*/React.createElement("span", {
    className: "".concat(SELECT_DISPLAY_NAME, "__multi-value__optionIcon")
  }, icon), props.data.label));
};
SingleValue.displayName = 'SingleValue';
var valueAsArray = function valueAsArray(value) {
  return value ? Array.isArray(value) ? value : [value] : DEFAULT_VALUE;
};
var MultiSelectInput = exports.MultiSelectInput = /*#__PURE__*/function (_React$PureComponent) {
  function MultiSelectInput() {
    var _this;
    (0, _classCallCheck2.default)(this, MultiSelectInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MultiSelectInput, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", MultiSelectInput.getDerivedInitialStateFromProps(_this.props));
    (0, _defineProperty2.default)(_this, "handleBlur", function () {
      var _this$props = _this.props,
        id = _this$props.id,
        ref = _this$props.inputRef,
        name = _this$props.name,
        onBlur = _this$props.onBlur;
      if (ref && (0, _typeof2.default)(ref) === 'object' && ref.current && (0, _typeof2.default)(ref.current) === 'object') {
        var defaultValue = valueAsArray(ref.current.state.value);
        var label = defaultValue.map(function (_ref7) {
          var label = _ref7.label;
          return label;
        });
        var value = defaultValue.map(function (_ref8) {
          var value = _ref8.value;
          return value;
        });
        if (typeof onBlur === 'function') {
          // Parameter types of an unknown function are unknown
          // (https://github.com/facebook/flow/issues/7702)
          // $FlowIgnore
          onBlur({
            currentTarget: {
              id: id,
              label: label,
              name: name,
              value: value
            }
          });
        }
      }
    });
    (0, _defineProperty2.default)(_this, "handleChange", function (valueProp /*: ValueType*/) {
      var _this$props2 = _this.props,
        id = _this$props2.id,
        name = _this$props2.name,
        onChange = _this$props2.onChange;
      var defaultValue = valueAsArray(valueProp);
      var label = defaultValue.map(function (_ref9) {
        var label = _ref9.label;
        return label;
      });
      var value = defaultValue.map(function (_ref0) {
        var value = _ref0.value;
        return value;
      });
      _this.setState({
        defaultValue: defaultValue
      });
      if (typeof onChange === 'function') {
        // Parameter types of an unknown function are unknown
        // (https://github.com/facebook/flow/issues/7702)
        // $FlowIgnore
        onChange({
          currentTarget: {
            id: id,
            label: label,
            name: name,
            value: value
          }
        }, valueProp, defaultValue);
      }
    });
    return _this;
  }
  (0, _inherits2.default)(MultiSelectInput, _React$PureComponent);
  return (0, _createClass2.default)(MultiSelectInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        dataTestID = _this$props3['data-testid'],
        autoFocus = _this$props3.autoFocus,
        classes = _this$props3.classes,
        className = _this$props3.className,
        Component = _this$props3.component,
        defaultValueProp = _this$props3.defaultValue,
        disabled = _this$props3.disabled,
        displayErrors = _this$props3.displayErrors,
        embedded = _this$props3.embedded,
        fixedMenuHeight = _this$props3.fixedMenuHeight,
        hasError = _this$props3.hasError,
        hasRequired = _this$props3.hasRequired,
        hasSuccess = _this$props3.hasSuccess,
        hasValidation = _this$props3.hasValidation,
        id = _this$props3.id,
        inputClassName = _this$props3.inputClassName,
        ref = _this$props3.inputRef,
        intl = _this$props3.intl,
        isDisabledProp = _this$props3.isDisabled,
        isMulti = _this$props3.isMulti,
        isSearchable = _this$props3.isSearchable,
        modalViewContext = _this$props3.modalViewContext,
        name = _this$props3.name,
        noOptionsMessage = _this$props3.noOptionsMessage,
        onBlur = _this$props3.onBlur,
        onChange = _this$props3.onChange,
        onPaste = _this$props3.onPaste,
        optionsProp = _this$props3.options,
        readOnly = _this$props3.readOnly,
        required = _this$props3.required,
        setDisplayErrorsState = _this$props3.setDisplayErrorsState,
        setLoadingState = _this$props3.setLoadingState,
        theme = _this$props3.theme,
        title = _this$props3.title,
        props = (0, _objectWithoutProperties2.default)(_this$props3, _excluded3);
      var defaultValue = this.state.defaultValue;
      var hasValue = Array.isArray(defaultValue) ? defaultValue.length > 0 : defaultValue !== undefined && defaultValue !== null && defaultValue !== '';
      var isRequired = required && !hasValue;
      // We're filtering out null values from options and defaultValue
      // so they don't render as empty options or values as a result of
      // https://github.com/catalyticlabs/catalytic-web/pull/2399
      var options = Array.isArray(optionsProp) ? optionsProp.filter(function (_ref1) {
        var value = _ref1.value;
        return value !== null;
      }) : optionsProp;
      return /*#__PURE__*/React.createElement("div", {
        className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.embedded, embedded), className),
        "data-testid": dataTestID || name || 'multi-select-input',
        onPaste: onPaste,
        title: title
      }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.input, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.success, hasSuccess || displayErrors && !isRequired), classes.error, hasError || displayErrors && isRequired), classes.readOnly, readOnly), classes.fixedMenuHeight, fixedMenuHeight)),
        classNamePrefix: SELECT_DISPLAY_NAME,
        closeMenuOnSelect: !isMulti,
        components: {
          ClearIndicator: ClearIndicator,
          Control: Control,
          IndicatorSeparator: IndicatorSeparator,
          LoadingIndicator: LoadingIndicator,
          Menu: Menu,
          MultiValueLabel: MultiValueLabel,
          Option: Option,
          SingleValue: SingleValue
        },
        inputClassName: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.inputElement, !isSearchable), inputClassName),
        inputId: id,
        isDisabled: isDisabledProp || disabled || readOnly,
        loadingMessage: function loadingMessage() {
          return (
            /*#__PURE__*/
            // noOptionsMessage and loadingMessage should support ReactNode
            // https://github.com/JedWatson/react-select/issues/3511
            // $FlowIgnore
            React.createElement(_Text.SmallText, {
              className: classes.menuNotice
            }, /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
              id: "multiSelectInput.loading",
              defaultMessage: "Loading..."
            }))
          );
        },
        noOptionsMessage: noOptionsMessage === undefined ? function () {
          return (
            /*#__PURE__*/
            // eslint-disable-next-line flowtype-errors/show-errors
            React.createElement(_Text.SmallText, {
              className: classes.menuNotice
            }, /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
              id: "multiSelectInput.noOptions",
              defaultMessage: "No options found."
            }))
          );
        } : noOptionsMessage,
        onBlur: function onBlur() {
          setTimeout(_this2.handleBlur, 0);
        },
        onChange: this.handleChange,
        openMenuOnFocus: autoFocus,
        styles: {
          // Omit outline style to keep focus outline for keyboard navigation
          control: function control(_ref10) {
            var outline = _ref10.outline,
              styles = (0, _objectWithoutProperties2.default)(_ref10, _excluded4);
            return styles;
          }
        },
        tabSelectsValue: false
      }, _objectSpread({
        defaultValue: defaultValue,
        isMulti: isMulti,
        isSearchable: isSearchable,
        name: name,
        options: options,
        ref: ref,
        required: required
      }, props))), required && /*#__PURE__*/React.createElement("div", {
        className: classes.required
      }, /*#__PURE__*/React.createElement("input", {
        className: classes.inputShadow,
        "data-name": name,
        onChange: NOOP,
        required: true,
        value: defaultValue
      }), !hasValue && /*#__PURE__*/React.createElement(_InputRequired.default, {
        disabled: disabled,
        hasRequired: hasRequired,
        readOnly: readOnly
      })));
    }
  }], [{
    key: "getDerivedInitialStateFromProps",
    value:
    // This is only a static method for ease of testing
    function getDerivedInitialStateFromProps(props /*: MultiSelectInputType*/) /*: State*/{
      var defaultValueProp = props.defaultValue;
      return {
        defaultValue: (0, _typeof2.default)(defaultValueProp) !== 'object' ? DEFAULT_VALUE : Array.isArray(defaultValueProp) ?
        // We're filtering out null values from options and defaultValue
        // so they don't render as empty options or values as a result of
        // https://github.com/catalyticlabs/catalytic-web/pull/2399
        defaultValueProp.filter(function (option /*: OptionType*/) {
          return option.value !== null;
        }) : defaultValueProp
      };
    }
  }]);
}(React.PureComponent);
(0, _defineProperty2.default)(MultiSelectInput, "displayName", SELECT_DISPLAY_NAME);
(0, _defineProperty2.default)(MultiSelectInput, "defaultProps", {
  autoComplete: false,
  autoFocus: false,
  component: _reactSelect.default,
  disabled: false,
  displayErrors: false,
  embedded: false,
  fixedMenuHeight: false,
  hasError: false,
  hasRequired: true,
  hasSuccess: false,
  isClearable: true,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isSearchable: true,
  maxMenuHeight: MENU_MAX_HEIGHT,
  menuPlacement: 'auto',
  options: DEFAULT_VALUE,
  readOnly: false,
  required: false
});
var EnhancedMultiSelectInput /*: React.ComponentType<MultiSelectInputProps>*/ = (0, _recompose.compose)((0, _recompose.setDisplayName)(SELECT_DISPLAY_NAME), _ModalView.withModalViewContext, _reactIntl.injectIntl, (0, _injectSheet.default)(Style), (0, _recompose.withProps)(function (_ref11) {
  var inputRef = _ref11.inputRef;
  return {
    inputRef: inputRef || React.createRef()
  };
}))(MultiSelectInput);
var _default = exports.default = EnhancedMultiSelectInput;
//# sourceMappingURL=MultiSelectInput.js.map